import React from "react";
import { Switch, BrowserRouter as Router, Route } from "react-router-dom";
import Login from "../Auth/Login";
import SignUp from "../Auth/SignUp";
import AuthCheck from "./authCheckRoute";
import { Alert } from "@hedgefund/shared/src/Alert";
import { setDefaultHeader } from "../../services/axiosClient";
import ProtectedApp from "./ProtectedApp";
import ForgetPassword from "../Auth/ForgetPassword";
import ResetPassword from "../Auth/RestPassword";
import ImpersonationUserLogin from "../Auth/Impersonation";

const App = () => {
  setDefaultHeader();
  return (
    <Router>
      <Alert />
      <Switch>
        <AuthCheck exact path="/login:callback?" Component={Login} />
        <AuthCheck exact path="/sign-up" Component={SignUp} />
        <AuthCheck path="/forget-password" Component={ForgetPassword} />
        <AuthCheck path="/resetPassword" Component={ResetPassword} />
        <Route
          path="/impersonationLogin/:token"
          render={() => { return <ImpersonationUserLogin /> }}
        />
        <ProtectedApp />
      </Switch>
    </Router>
  );
};

export default App;
